/**
 * B2-RIDE - OpenAPI 3.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2.0.0
 * Contact: mobile@pikyrent.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { WebhookEventLog } from '../model/webhookEventLog';
import { WebhookEventLogListResponse } from '../model/webhookEventLogListResponse';
import { WebhookEventLogSortField } from '../model/webhookEventLogSortField';
import { WebhookEventLogStatus } from '../model/webhookEventLogStatus';
import { WebhookEventTypesResponse } from '../model/webhookEventTypesResponse';
import { WebhookSettings } from '../model/webhookSettings';
import { WebhookSettingsCreateRequest } from '../model/webhookSettingsCreateRequest';
import { WebhookSettingsListResponse } from '../model/webhookSettingsListResponse';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class WebhookApiService {

    protected basePath = 'https://app-tst.pikyrent.com:33443';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Delete webhook event log by ID
     * Deletes the webhook event log with the given ID.
     * @param id ID of the webhook event log entry to delete
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteWebhookEventLog(id: number, observe?: 'body', reportProgress?: boolean): Observable<WebhookEventLog>;
    public deleteWebhookEventLog(id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<WebhookEventLog>>;
    public deleteWebhookEventLog(id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<WebhookEventLog>>;
    public deleteWebhookEventLog(id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteWebhookEventLog.');
        }

        let headers = this.defaultHeaders;

        // authentication (accessToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Auth"]) {
            headers = headers.set('Auth', this.configuration.apiKeys["Auth"]);
        }

        // authentication (apiKey) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["ApiKey"]) {
            headers = headers.set('ApiKey', this.configuration.apiKeys["ApiKey"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<WebhookEventLog>('delete',`${this.basePath}/webhooks/event-logs/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete webhook settings by ID
     * Deletes the webhook settings with the given ID. 
     * @param id ID of the webhook settings entry to delete
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteWebhookSettings(id: number, observe?: 'body', reportProgress?: boolean): Observable<WebhookSettings>;
    public deleteWebhookSettings(id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<WebhookSettings>>;
    public deleteWebhookSettings(id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<WebhookSettings>>;
    public deleteWebhookSettings(id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteWebhookSettings.');
        }

        let headers = this.defaultHeaders;

        // authentication (accessToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Auth"]) {
            headers = headers.set('Auth', this.configuration.apiKeys["Auth"]);
        }

        // authentication (apiKey) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["ApiKey"]) {
            headers = headers.set('ApiKey', this.configuration.apiKeys["ApiKey"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<WebhookSettings>('delete',`${this.basePath}/webhooks/settings/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get webhook event log by ID
     * Returns a single webhook event log entry by its ID.
     * @param id ID of the webhook event log entry
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getWebhookEventLogById(id: number, observe?: 'body', reportProgress?: boolean): Observable<WebhookEventLog>;
    public getWebhookEventLogById(id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<WebhookEventLog>>;
    public getWebhookEventLogById(id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<WebhookEventLog>>;
    public getWebhookEventLogById(id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getWebhookEventLogById.');
        }

        let headers = this.defaultHeaders;

        // authentication (accessToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Auth"]) {
            headers = headers.set('Auth', this.configuration.apiKeys["Auth"]);
        }

        // authentication (apiKey) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["ApiKey"]) {
            headers = headers.set('ApiKey', this.configuration.apiKeys["ApiKey"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<WebhookEventLog>('get',`${this.basePath}/webhooks/event-logs/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get webhook settings by ID
     * Returns the webhook settings associated with the specified ID. The secret key is never included in responses. 
     * @param id ID of the webhook settings entry
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getWebhookSettingsById(id: number, observe?: 'body', reportProgress?: boolean): Observable<WebhookSettings>;
    public getWebhookSettingsById(id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<WebhookSettings>>;
    public getWebhookSettingsById(id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<WebhookSettings>>;
    public getWebhookSettingsById(id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getWebhookSettingsById.');
        }

        let headers = this.defaultHeaders;

        // authentication (accessToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Auth"]) {
            headers = headers.set('Auth', this.configuration.apiKeys["Auth"]);
        }

        // authentication (apiKey) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["ApiKey"]) {
            headers = headers.set('ApiKey', this.configuration.apiKeys["ApiKey"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<WebhookSettings>('get',`${this.basePath}/webhooks/settings/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * List webhook event logs
     * Returns a paginated list of webhook event delivery attempts (logs).   Supports filtering by event ID, webhook settings, status, and sorting. 
     * @param page Page number to retrieve
     * @param limit Number of records per page
     * @param eventId Filter logs by event identifier
     * @param webhookSettingsId Filter logs by webhook settings ID
     * @param status Filter logs by delivery status
     * @param sortField Field used to sort the results
     * @param sortOrder Sort direction
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listWebhookEventLogs(page?: number, limit?: number, eventId?: string, webhookSettingsId?: number, status?: WebhookEventLogStatus, sortField?: WebhookEventLogSortField, sortOrder?: string, observe?: 'body', reportProgress?: boolean): Observable<WebhookEventLogListResponse>;
    public listWebhookEventLogs(page?: number, limit?: number, eventId?: string, webhookSettingsId?: number, status?: WebhookEventLogStatus, sortField?: WebhookEventLogSortField, sortOrder?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<WebhookEventLogListResponse>>;
    public listWebhookEventLogs(page?: number, limit?: number, eventId?: string, webhookSettingsId?: number, status?: WebhookEventLogStatus, sortField?: WebhookEventLogSortField, sortOrder?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<WebhookEventLogListResponse>>;
    public listWebhookEventLogs(page?: number, limit?: number, eventId?: string, webhookSettingsId?: number, status?: WebhookEventLogStatus, sortField?: WebhookEventLogSortField, sortOrder?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {








        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (eventId !== undefined && eventId !== null) {
            queryParameters = queryParameters.set('eventId', <any>eventId);
        }
        if (webhookSettingsId !== undefined && webhookSettingsId !== null) {
            queryParameters = queryParameters.set('webhookSettingsId', <any>webhookSettingsId);
        }
        if (status !== undefined && status !== null) {
            queryParameters = queryParameters.set('status', <any>status);
        }
        if (sortField !== undefined && sortField !== null) {
            queryParameters = queryParameters.set('sortField', <any>sortField);
        }
        if (sortOrder !== undefined && sortOrder !== null) {
            queryParameters = queryParameters.set('sortOrder', <any>sortOrder);
        }

        let headers = this.defaultHeaders;

        // authentication (accessToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Auth"]) {
            headers = headers.set('Auth', this.configuration.apiKeys["Auth"]);
        }

        // authentication (apiKey) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["ApiKey"]) {
            headers = headers.set('ApiKey', this.configuration.apiKeys["ApiKey"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<WebhookEventLogListResponse>('get',`${this.basePath}/webhooks/event-logs`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * List available webhook event types
     * Returns a dictionary containing all supported webhook event types.   Keys represent enum-like identifiers, and values contain the event string used in subscriptions. 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listWebhookEventTypes(observe?: 'body', reportProgress?: boolean): Observable<WebhookEventTypesResponse>;
    public listWebhookEventTypes(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<WebhookEventTypesResponse>>;
    public listWebhookEventTypes(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<WebhookEventTypesResponse>>;
    public listWebhookEventTypes(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (accessToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Auth"]) {
            headers = headers.set('Auth', this.configuration.apiKeys["Auth"]);
        }

        // authentication (apiKey) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["ApiKey"]) {
            headers = headers.set('ApiKey', this.configuration.apiKeys["ApiKey"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<WebhookEventTypesResponse>('get',`${this.basePath}/webhooks/event-types`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * List webhook settings
     * Returns a paginated list of webhook settings.   Supports pagination and sorting by a selected field. 
     * @param page Page number to retrieve
     * @param limit Number of records per page
     * @param sortField Field used to sort the results
     * @param sortOrder Sort direction
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listWebhookSettings(page?: number, limit?: number, sortField?: string, sortOrder?: string, observe?: 'body', reportProgress?: boolean): Observable<WebhookSettingsListResponse>;
    public listWebhookSettings(page?: number, limit?: number, sortField?: string, sortOrder?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<WebhookSettingsListResponse>>;
    public listWebhookSettings(page?: number, limit?: number, sortField?: string, sortOrder?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<WebhookSettingsListResponse>>;
    public listWebhookSettings(page?: number, limit?: number, sortField?: string, sortOrder?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (sortField !== undefined && sortField !== null) {
            queryParameters = queryParameters.set('sortField', <any>sortField);
        }
        if (sortOrder !== undefined && sortOrder !== null) {
            queryParameters = queryParameters.set('sortOrder', <any>sortOrder);
        }

        let headers = this.defaultHeaders;

        // authentication (accessToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Auth"]) {
            headers = headers.set('Auth', this.configuration.apiKeys["Auth"]);
        }

        // authentication (apiKey) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["ApiKey"]) {
            headers = headers.set('ApiKey', this.configuration.apiKeys["ApiKey"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<WebhookSettingsListResponse>('get',`${this.basePath}/webhooks/settings`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update webhook settings
     * Updates the webhook settings for the given ID.   The secret key is accepted in the request but **never returned** in the response. 
     * @param body 
     * @param id ID of the webhook settings entry
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateWebhookSettings(body: WebhookSettingsCreateRequest, id: number, observe?: 'body', reportProgress?: boolean): Observable<WebhookSettings>;
    public updateWebhookSettings(body: WebhookSettingsCreateRequest, id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<WebhookSettings>>;
    public updateWebhookSettings(body: WebhookSettingsCreateRequest, id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<WebhookSettings>>;
    public updateWebhookSettings(body: WebhookSettingsCreateRequest, id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateWebhookSettings.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling updateWebhookSettings.');
        }

        let headers = this.defaultHeaders;

        // authentication (accessToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Auth"]) {
            headers = headers.set('Auth', this.configuration.apiKeys["Auth"]);
        }

        // authentication (apiKey) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["ApiKey"]) {
            headers = headers.set('ApiKey', this.configuration.apiKeys["ApiKey"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<WebhookSettings>('patch',`${this.basePath}/webhooks/settings/${encodeURIComponent(String(id))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create or update webhook settings
     * Creates or updates webhook settings for the authenticated user or provider. The request includes the target domain URL, a secret key for signing webhooks and the list of subscribed events. The secret key is never returned in the response. 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public upsertWebhookSettings(body: WebhookSettingsCreateRequest, observe?: 'body', reportProgress?: boolean): Observable<WebhookSettings>;
    public upsertWebhookSettings(body: WebhookSettingsCreateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<WebhookSettings>>;
    public upsertWebhookSettings(body: WebhookSettingsCreateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<WebhookSettings>>;
    public upsertWebhookSettings(body: WebhookSettingsCreateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling upsertWebhookSettings.');
        }

        let headers = this.defaultHeaders;

        // authentication (accessToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Auth"]) {
            headers = headers.set('Auth', this.configuration.apiKeys["Auth"]);
        }

        // authentication (apiKey) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["ApiKey"]) {
            headers = headers.set('ApiKey', this.configuration.apiKeys["ApiKey"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<WebhookSettings>('post',`${this.basePath}/webhooks/settings`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
